/**
  This module include various functions to be used by the resource classes.
*/

//This function leverage dom position to sort htmlNode elements
function compareHtmlNodes(a, b) {
  if (a.compareDocumentPosition(b) === 2 || a.compareDocumentPosition(b) === 8) {
    return 1;
  }
  if (a.compareDocumentPosition(b) === 4 || a.compareDocumentPosition(b) === 16) {
    return -1;
  }
  return 0;
}

/* this function sets basic properties of an UI html element such as id and type
 * this is implemented based on the type  of the predesigned element and its structure
 */
function getSingleUIProps(inputElement) {
  let uiprops = {};
  uiprops.id = inputElement.getAttribute("id");
  uiprops.tagName = inputElement.tagName;
  uiprops.type = inputElement.getAttribute("type") || "";
  return uiprops;
}

module.exports = {
  compareHtmlNodes: compareHtmlNodes,
  getSingleUIProps:getSingleUIProps
}
